import React from 'react'
import Row from '../../GuidePages/ArticleComponents/Row'
import styles from './Message.module.css'

function Message() {

    const row = {
        listItem: ["Add resource leads by logging in after google authentication.", "Add requests for resources that you need", "Links to all the necessary websites in cases of emergency","Covid related Guides written by various members in our organization."]
    }
    return (
        <div className={styles.component}>
        <div className={styles.innerCover}>
            <h1>What does this platform do?</h1><br/><br/>
            <p style={{textAlign:"center", fontSize:'0.8rem'}}>This platform works on the principle of <span className={styles.highBold}>"For the people"</span> and <span className={styles.highBold}>"By the people"</span> and so will be useful to it full potential if everyone contributes.</p>

            <p style={{textAlign:"center", fontSize:'0.8rem'}}>Amidst these tough times there have been a lot of people coming forth to help others find resources and utilities to fight Covid-19.</p>
           
            <span style={{display:'flex',justifyContent:"center"}}>
            <Row row={row}/>
            </span>
            <p style={{textAlign:"center", fontSize:'0.8rem'}}>We had also noticed that people faced issues due to the <span className={styles.highBold}>inappropriate behaviour of individuals</span> when contacted for leads. Taking that into account, we have also added two buttons <span className={styles.highBold}>"Report as Inappropriate"</span> (permanently puts a ban on the user account when reported for three times by different people) and <span className={styles.highBold}>"Mark as Not responding"</span> (Marks a resources handler as not responding and deletes the resource if reported for 5 times)</p>
            <br/>
            <p style={{textAlign:"center", fontSize:'0.8rem'}}>We hope that this platform is helpful for all the user across the country.</p>
            <p style={{textAlign:"center", fontSize:'0.8rem'}}>(Please note that this is a student made project and so we weren't able to scale it to all India level and so the website might crash soon. To fund the project please contact through mail.) </p>

            </div>
        </div>
    )
}

export default Message
